import { render, staticRenderFns } from "./CentroHemodinamicaComponente.vue?vue&type=template&id=8083ab04&scoped=true"
import script from "./CentroHemodinamicaComponente.vue?vue&type=script&lang=js"
export * from "./CentroHemodinamicaComponente.vue?vue&type=script&lang=js"
import style0 from "./CentroHemodinamicaComponente.vue?vue&type=style&index=0&id=8083ab04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8083ab04",
  null
  
)

export default component.exports